<div
    class="p-3"
    style="overflow-y: auto; max-height: 85vh;"
>
    <button
        class="print-modal"
        [matMenuTriggerFor]="printMenu"
        [matTooltip]="'learningSectionContainer.printPreview' | transloco"
        aria-label="{{'learningSectionContainer.printPreview' | transloco}}"
    >
        <mat-icon>print</mat-icon>
    </button>
    <mat-menu #printMenu="matMenu">
        <button mat-menu-item (click)="openPrint('generic')">
            {{ 'learningSectionContainer.printTemplateGeneric' | transloco }}
        </button>
        <button mat-menu-item (click)="openPrint('abu')">
            {{ 'learningSectionContainer.printTemplateAbu' | transloco }}
        </button>
    </mat-menu>
    <div
        class="close-modal"
        (click)="onClose()"
        (keydown.escape)="onClose()"
        tabindex="0"
    >
        <mat-icon>close</mat-icon>
    </div>

    <h1>{{ form.get('name')?.value || '' }}</h1>

    <div class="learning-section-options mt-4">
        <button
            mat-stroked-button
            color="primary"
            [matMenuTriggerFor]="addElementMenu"
            class="mb-3"
        >
            <mat-icon>add</mat-icon> {{ 'learningSectionContainer.addElement' | transloco }}
        </button>
        <mat-checkbox
            [checked]="showContainerId()"
            (change)="toggleContainerId()"
        >
            Container-ID anzeigen
        </mat-checkbox>

        <mat-menu #addElementMenu="matMenu" class="element-picker-menu">
            <button mat-menu-item (click)="addContainer()" class="picker-item">
                <span class="picker-icon">▣</span>
                <div class="picker-info">
                    <div class="picker-label">{{ 'learningSectionContainer.elementContainer' | transloco }}</div>
                    <div class="picker-desc">{{ 'learningSectionContainer.elementContainerDesc' | transloco }}</div>
                </div>
            </button>
            <button mat-menu-item (click)="addButtonBar()" class="picker-item">
                <span class="picker-icon">⊟</span>
                <div class="picker-info">
                    <div class="picker-label">{{ 'learningSectionContainer.elementButtonBar' | transloco }}</div>
                    <div class="picker-desc">{{ 'learningSectionContainer.elementButtonBarDesc' | transloco }}</div>
                </div>
            </button>
        </mat-menu>

        @if (this.getPreviewLink()) {
        <a
            mat-flat-button
            color="primary"
            href="{{ this.getPreviewLink() }}"
            target="_blank"
        >
            <mat-icon>remove_red_eye</mat-icon> {{ 'learningSectionContainer.preview' | transloco }}
        </a>
        }


        <mat-form-field>
            <mat-label>{{ 'learningSectionContainer.layout' | transloco }}</mat-label>
            <mat-select
                [(value)]="selectedLayoutOption"
                (selectionChange)="onChangeLayout($event.value)"
            >
                @for (learningSectionLayout of learningSectionLayouts$ | async; track learningSectionLayout) {
                <mat-option [value]="learningSectionLayout">{{ learningSectionLayout.name }}</mat-option>
                }
            </mat-select>
        </mat-form-field>
    </div>

    <div
        class="learning-section-rows-container"
        cdkDropList
        [cdkDropListData]="sectionRows"
        (cdkDropListDropped)="dropRow($event)"
    >
        @for (row of sectionRows; track rowIdx; let rowIdx = $index) {
            <div class="draggable-row" cdkDrag>
                <div class="drag-handle" cdkDragHandle>⠿</div>

                @if (row.type === 'containers') {
                    <div
                        class="row-inner"
                        [class.row-full-disabled]="isDraggingContainer && isRowFull(rowIdx)"
                        cdkDropList
                        cdkDropListOrientation="horizontal"
                        [id]="'container-row-' + rowIdx"
                        [cdkDropListData]="row.containers"
                        [cdkDropListConnectedTo]="getConnectedDropListIds(rowIdx)"
                        [style.gridTemplateColumns]="gridTemplateColumns"
                        (cdkDropListEntered)="updateContainerPreviewWidth($event)"
                        (cdkDropListSorted)="updateContainerPreviewWidth($event)"
                        (cdkDropListDropped)="dropContainer($event)"
                    >
                        @for (container of row.containers; track $index) {
                            @if (container) {
                                <div
                                    class="learning-section-grid-item"
                                    [class.full]="container.fullWidth"
                                    [style.grid-column]="container.fullWidth ? '1 / -1' : 'auto'"
                                    cdkDrag
                                    [cdkDragData]="container"
                                    (cdkDragStarted)="isDraggingContainer = true"
                                    (cdkDragReleased)="isDraggingContainer = false"
                                >
                                    <div class="learning-section-grid-content">
                                        <span
                                            [title]="'learningSectionContainer.editByClick' | transloco"
                                            (click)="editLearningSectionSingleContainer(container)"
                                            (keydown.enter)="editLearningSectionSingleContainer(container)"
                                            tabindex="0"
                                        >
                                            <div class="container-title">{{ container.title }}</div>
                                            <div class="container-content">
                                                <div class="name">{{ containerContentData[container.id]?.name }}</div>
                                                <div class="type">{{ getContentTypeLabel(containerContentData[container.id]?.type) }}</div>
                                            </div>
                                        </span>
                                        <div
                                            class="remove"
                                            tabindex="0"
                                            (click)="removeContainer(container)"
                                            (keydown.enter)="removeContainer(container)"
                                        >
                                            <mat-icon>close</mat-icon>
                                        </div>
                                        @if (showContainerId()) {<div
                                            class="container-id"
                                            title="Doppelklick zum Kopieren"
                                            (dblclick)="copyContainerIdToClipboard(container.id)"
                                        >
                                            {{ container.id }}
                                        </div>}
                                    </div>
                                </div>
                            } @else {
                                <div
                                    class="learning-section-grid-item empty-slot"
                                    cdkDrag
                                    [cdkDragDisabled]="true"
                                >
                                    <button
                                        class="empty-slot-add-btn"
                                        (click)="createContainerAtSlot(rowIdx, $index)"
                                    >
                                        <mat-icon>add</mat-icon>
                                    </button>
                                </div>
                            }
                        }
                    </div>
                }

                @if (row.type === 'button-bar') {
                    <div class="button-bar-row">
                        <button
                            class="button-bar-delete"
                            (click)="removeButtonBar(row)"
                            tabindex="0"
                        >
                            <mat-icon>close</mat-icon>
                        </button>
                        <div class="button-bar-header">
                            <span class="button-bar-label">{{ 'learningSectionContainer.buttonBar' | transloco }}</span>
                            <div class="button-bar-controls">
                                <span class="btn-count-label">{{ 'learningSectionContainer.buttonCount' | transloco }}:</span>
                                <input
                                    class="btn--input"
                                    type="number"
                                    min="1"
                                    max="5"
                                    [value]="row.buttonCount"
                                    (input)="updateButtonCount(row, $any($event.target).value, $event)"
                                >
                            </div>
                        </div>
                        <div
                            class="button-bar-buttons"
                            cdkDropList
                            cdkDropListOrientation="horizontal"
                            [id]="'button-bar-' + rowIdx"
                            [cdkDropListData]="row.items"
                            [cdkDropListConnectedTo]="getConnectedButtonBarDropListIds(rowIdx)"
                            (cdkDropListDropped)="dropButtonItem($event, row)"
                        >
                            @for (item of row.items; track $index) {
                                <div
                                    class="btn-item"
                                    cdkDrag
                                    (click)="editButtonBarItem(row, $index)"
                                    (keydown.enter)="editButtonBarItem(row, $index)"
                                    tabindex="0"
                                >
                                    <div class="btn-item-label">{{ item.label }}</div>
                                    @if (buttonItemContentData[rowIdx + '-' + $index]; as contentInfo) {
                                        <div class="btn-item-content">
                                            <div class="btn-item-content-name">{{ contentInfo.name }}</div>
                                            <div class="btn-item-content-type">{{ getContentTypeLabel(contentInfo.type) }}</div>
                                        </div>
                                    }
                                    <button
                                        class="btn-item-delete"
                                        (click)="removeButtonItem(row, $index); $event.stopPropagation()"
                                        tabindex="0"
                                    >✕</button>
                                </div>
                            }
                        </div>
                    </div>
                }
            </div>
        }

    </div>
</div>